import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { colors } from '../styles';

const styles = css`
  border-top: 25px solid ${colors.color3Dark};
  .footer-content {
    padding: 20px 0;
    background-color: ${colors.color3};
    text-align: center;
    p {
      font-size: 15px;
      font-weight: 300;
      strong {
        font-weight: bold;
      }
    }
  }
  .footer-logo {
    display: inline-block;
    padding: 15px 0 25px 0;
  }
  .footer-menu {
    display: none;
    @media (min-width: 992px) {
      display: inline-block;
      padding: 0;
      margin: 0 auto;
      vertical-align: top;
      list-style: none;
      li {
        display: inline-block;
        a {
          padding: 0 10px;
          border-right: 1px solid ${colors.color1};
          font-size: 13px;
          line-height: 24px;
          font-weight: bold;
          text-transform: uppercase;
          color: ${colors.color1};
        }
      }
      li:last-child {
        a {
          border-right: none;
        }
      }
    }
  }
  .contact-info {
    width: 100%;
    margin-top: 20px;
  }
  .copyright {
    text-align: center;
    background-color: ${colors.color3Dark};
    padding: 15px 15px 100px 15px;
    @media (min-width: 992px) {
      padding-bottom: 15px;
    }
  }
  .copyright-details {
    span {
      display: block;
      margin-right: 5px;
    }
    @media (min-width: 992px) {
      span {
        display: inline-block;
      }
    }
  }
  .EOH-logo {
    position: absolute;
    right: 20px;
    height: 25px;
    margin-top: 25px;
    @media (min-width: 992px) {
      margin-top: 0;
    }
  }
  .EHO-logo {
    height: 50px;
    margin: auto;
    @media (min-width: 992px) {
      margin-top: 0;
    }
  }

`;

function Footer({ builder }) {
  return (
    <div className={styles}>
      <div className="footer-content">
        <Link className="footer-logo" name="index">
          <img src="/images/woodbridge-logo.svg" alt="Woodbridge Logo" />
        </Link>
        <div className="container">
          <div className="row">
            <ul className="footer-menu">
              <li><Link name="communities">Our Communities</Link></li>
              <li><Link name="homes">Our Homes</Link></li>
              <li><Link name="photo-gallery">Photo Gallery</Link></li>
              <li><Link name="about-us">About Us</Link></li>
            </ul>
            <div className="contact-info">
              <p>
                <strong>Owned and Operated by Landtec Companies</strong><br />
                {get(builder, 'address.streetAddress')}<br />
                {get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.postalCode')}<br />
                <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>{get(builder, 'phone_number_display')}</a>
              </p>
            </div>
            <img className="EHO-logo" src="/images/EHO-logo.jpg" alt="Equal Opportunity Housing Logo" />
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <div className="row text-center copyright-details" style={{ display: 'inline-block' }}>
            <span>{`©${(new Date()).getFullYear()} Landtec Companies.`}</span>
            <span>All Rights Reserved.</span>
            <span>Site by <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer">Builder Designs</a></span>
          </div>
          <img className="EOH-logo" src="/images/icon-equal-housing.svg" alt="Equal Opportunity Housing Logo" />
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
})(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js